/**
 * Format an ISO date string to a readable format
 * @param isoString - ISO date string
 * @returns Formatted date string (e.g., "THU, JAN 23 · 8:00 PM")
 */
export function formatDate(isoString: string): string {
  const date = new Date(isoString);

  const weekdays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  const months = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];

  const weekday = weekdays[date.getDay()];
  const month = months[date.getMonth()];
  const day = date.getDate();

  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // Convert 0 to 12

  const minuteStr = minutes.toString().padStart(2, '0');

  return `${weekday}, ${month} ${day} · ${hours}:${minuteStr} ${ampm}`;
}

/**
 * Format an ISO date string to a time-only format
 * @param isoString - ISO date string
 * @returns Formatted time string (e.g., "8:00 PM - 10:00 PM")
 */
export function formatTimeRange(startIso: string, endIso: string): string {
  const startDate = new Date(startIso);
  const endDate = new Date(endIso);

  const formatTime = (date: Date) => {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const minuteStr = minutes.toString().padStart(2, '0');
    return `${hours}:${minuteStr} ${ampm}`;
  };

  return `${formatTime(startDate)} - ${formatTime(endDate)}`;
}
